// GENERADO POR HAIKU — no editar: se reescribe en cada regeneración.

/** Zona del proyecto: `timeZone` de la configuración de haiku, o `timeZones.es` si falta. La misma que la del server. */
export const PROJECT_TIME_ZONE = "America/Argentina/Buenos_Aires";
